export default {
    "banner": {
        "header": "M2PAY CARD ACCEPTANCE",
        "motto": "POS devices. Online. Mobile. Crypto.",
        "learn-more-button": "Send inquiry",
        "contact-us-button": "Contact us"
    },
    "reference": {
        "header": "References",
        "introduction": "Our satisfied clients"
    },
    "about-us": {
        "header": "About us",
        "paragraph": {
            "line-1": "POS devices. Online. Mobile. Crypto.",
            "line-2": "Ability to receive and process orders through a single POS device using an Android application.",
            "line-3": "After quick installation, the POS device is ready to accept debit and credit cards at the point of sale or in the field.",
            "line-4": "Our POS device can be used independently, connected to your cash register, or to a mobile device via the free M2PAY app.",
            "line-5": "Our solution is simple and transparent in terms of cost."
        }
    },
    "devices": {
        "header": "M2Pay mPOS Device",
        "introduction": "POS devices. Online. Mobile. Crypto.",
        "PAX-A35": {
            "line-1": "Designed for retail, shops, and self-service kiosks that need a fast, reliable, and compact device.",
            "line-2": "Intended for a wide range of businesses, including:",
            "list": {
                "item-1": "Supermarkets: Fast and efficient transaction processing for large volumes of customers.",
                "item-2": "Hospitality: Ideal solution for restaurants, cafes, and bars that need quick payments and integration with cash registers.",
                "item-3": "Self-service kiosks: Enables simple and secure self-purchase, reduces crowds, and improves user experience."
            },
            "line-3": "The POS terminal offers high reliability and payment security, improving productivity and customer satisfaction."
        },
        "PAX-A920Pro": {
            "line-1": "Fully mobile POS device (4G, WiFi, and Bluetooth) with a long-lasting battery ensures continuous operation throughout the entire workday.",
            "list": {
                "item-1": "Hospitality: Ideal for restaurants, cafes, and bars, enabling easy order management and payment directly at the table.",
                "item-2": "Retail: Fast and simple payments.",
                "item-3": "Ability to receive and process orders through a single POS device using an Android application.",
                "item-4": "After quick installation, the POS device is ready to accept debit and credit cards at the point of sale or in the field.",
                "item-5": "Our POS device can be used independently, connected to your cash register, or to a mobile device via the free M2PAY app.",
                "item-6": "Our solution is simple and transparent in terms of cost.",
                "item-7": "Ideal solution for small merchants where an all-in-one system is needed: cash register, fiscalization, and card payment acceptance."
            },
            "line-2": "PAX A920 Pro, thanks to its compact dimensions, long-lasting battery, and ease of use, is an ideal solution for businesses seeking a reliable, fast, and versatile POS device."
        },
        "PAX-A77": {
            "line-1": "MiniPOS – a smart POS terminal designed for restaurants, cafes, clubs, and other points of sale where mobility is needed.",
            "list": {
                "item-1": "Offers simple upgrades to existing applications for accepting cashless payments.",
                "item-2": "Enables sending orders to the cash register and processing payments, all through a single device, greatly simplifying operations.",
                "item-3": "Long-lasting autonomy means more working hours between charges.",
                "item-4": "After quick installation, the POS device is ready to accept debit and credit cards at the point of sale or in the field."
            }
        },
        "PAX-A80": {
            "line-1": "PAX A80 is a versatile POS terminal that can function as a fixed device on the counter or as a portable terminal for payments thanks to an optional battery.",
            "list": {
                "item-1": "Intended for supermarkets, pharmacies, and retail: Fast and efficient transaction processing for large volumes of customers.",
                "item-2": "Hospitality: Ideal solution for restaurants, cafes, and bars that need quick payments and integration with their own cash register.",
                "item-3": "After quick installation, the POS device is ready to accept debit and credit cards at the point of sale or in the field."
            },
            "line-2": "Robust and reliable, the A80 is ideal for businesses that need a stable and efficient payment solution."
        },
        "PAX-A960": {
            "line-1": "The most powerful POS device in the A series, extremely lightweight with great autonomy and the ability to print receipts on-site.",
            "list": {
                "item-1": "Ability to process payments, issue receipts, and send orders to the cash register, all in one device.",
                "item-2": "Ideal for hospitality and points of sale where mobility is required.",
                "item-3": "After quick installation, the POS device is ready to accept debit and credit cards at the point of sale or in the field.",
                "item-4": "Ideal solution for small merchants where an all-in-one system is needed: cash register, fiscalization, and card payment acceptance."
            }
        },
        "PAX-IM25": {
            "line-1": "Unattended POS device designed for use in all environments and weather conditions, making it ideal for places requiring self-service payments such as:",
            "list": {
                "item-1": "Parking lots: Secure and fast payment for parking.",
                "item-2": "Gas stations: Self-service payment for fuel and services.",
                "item-3": "EV charging stations: Contactless and simple payment for electric energy.",
                "item-4": "Vending machines: Payment at food and beverage machines.",
                "item-5": "Car washes: Payment for services directly at self-service car washes."
            },
            "line-2": "PAX IM25 is resistant to moisture, dirt, and scratches."
        }
    },
    "treasury": {
        "header": "POS Cash Register",
        "introduction": "Cash register with integrated card payments.",
        "flavour-text": {
            "line-1": "A package that solves the entire operation and payment process for small and medium-sized merchants at affordable prices!",
            "line-2": "Fiscal cash register integrated with M2Pay card payments enables micro and small businesses to accept card payments with low fees."
        },
        "checkmark-list": {
            "item-1": "One POS device as a cash register, fiscalization, and card acceptance with affordable fees",
            "item-2": "Payout to your IBAN the next business day",
            "item-3": "Purchase or monthly rental of the cash register",
            "item-4": "Support during installation and further operation"
        },
        "diamond-blocks": {
            "block-1": {
                "message-1": "Card payments integrated with the cash register",
                "message-2": "Purchase or rental model",
                "message-3": "Installation, customer support, training",
                "message-4": "Free app upgrades"
            },
            "block-2": {
                "message-1": "Monitoring legal changes",
                "message-2": "Acceptance of Maestro, Mastercard, Visa, Diners, Union Pay, and JCB cards with favorable fees",
                "message-3": "No need to open a new bank account – funds are deposited into your existing account",
                "message-4": "Offline operation – ability to issue receipts in case of internet connection loss"
            },
            "block-3": {
                "message-1": "User account in the Cloud for data administration",
                "message-2": "Automatic data backup in the Cloud",
                "message-3": "Upgradeable with additional modules – inventory management, recipes, local trips, travel orders, etc.",
                "message-4": "Online insight into card transactions and report generation"
            }
        }
    },
    "partners": {
        "header": "Partners",
        "explanation": {
            "line-1-1": "We rely on a network of over",
            "line-1-2": "to ensure the highest quality service for accepting cashless payments.",
            "line-2": "Have your own customer base and want to join the M2PAY platform? Contact us!"
        },
        "button": "Become a partner"
    },
    "online-payments": {
        "header": "Online Payments",
        "list-1": {
            "item-1": "Ready and standard solutions for online payments",
            "item-2": "Pay by link",
            "item-3": "Integration with many online store service providers",
            "item-4": "Virtual terminal"
        },
        "phone-messages": {
            "message-1": "Fast and simple",
            "message-2": "Generating a link for online payment",
            "message-3": "WooCommerce, Magento, PrestaShop, Shopify, and others",
            "message-4": "Make payments online directly via the web interface",
            "message-5": "Save data for recurring payments",
            "message-6": "Support for payments via iOS devices",
            "message-7": "Support for payments via Android devices",
            "message-8": "Advice and assistance during and after integration"
        },
        "list-2": {
            "item-1": "Card tokenization",
            "item-2": "Apple Pay",
            "item-3": "Google Pay",
            "item-4": "IT support for online integrations with your website"
        }
    },
    "consultation": {
        "header": "Consulting and Training",
        "introduction": "Simplifying business",
        "explanation-1": {
            "line-1": "We connect our mobile POS devices with your fiscal cash registers, sales, and other business software, CRM, ERP, etc.",
            "line-2": "This integration enables better insight into transactions and data analysis for full control over your operations.",
            "line-3": "Pay per transaction, with no integration costs or hidden fees."
        },
        "list-1": {
            "item-1": "Initial consultation",
            "item-2": "Analysis of needs and existing solutions",
            "item-3": "Solution design and cost savings calculation"
        },
        "list-2": {
            "item-1": "Support in daily operations",
            "item-2": "Customized and simplified financial reporting",
            "item-3": "User education"
        },
        "explanation-2": {
            "line-1": "M2pay cashless payments for all types of businesses.",
            "line-2": "We enable cashless payments for small and large merchants as well as service providers, including those who currently lack the capability or cost-effectiveness to use them."
        }
    },
    "api": {
        "sub-header-part-1": "Our ",
        "sub-header-part-2": "API interfaces.",
        "content-1": {
            "paragraph": {
                "line-1": "Our transaction system is based on APIs tailored to various platforms.",
                "line-2-1": "We enable fast and simple",
                "line-2-2": "integration with your existing software, and our clients also have the option to integrate with",
                "line-2-3": "for control and detailed insight into transaction data needed for analytics."
            },
            "icon-infos": {
                "info-1": "Rest API",
                "info-2": "Billing API"
            }
        },
        "content-2": {
            "paragraph": {
                "line-1-1": "We offer our clients a ready solution with",
                "line-1-2": "for payments with virtual assets via our POS devices and online, providing fast and secure transaction processing in digital currencies, as well as integration with third-party software",
                "line-2-1": "For eCommerce businesses, we provide solutions with",
                "line-2-2": "for online payments with simple integration into your mobile apps and popular platforms like WooCommerce, Magento, PrestaShop, Shopify, and others, tailored to your web shop needs."
            },
            "icon-infos": {
                "info-1": "Crypto API",
                "info-2": "E-com API"
            }
        }
    },
    "footer": {
        "funding": {
            "header": "ESIF funds",
            "info": "Final recipient of a financial instrument co-financed by the European Regional Development Fund under the Operational Programme 'Competitiveness and Cohesion'."
        },
        "company-info": {
            "base-capital": "Base capital: 126,160.00 EUR fully paid.",
            "bank": "Current account at Partner Bank:",
            "hanfa-1": "The company is registered with",
            "hanfa-2": "as a provider of virtual asset services under serial number 14."
        },
        "contacts": {
            "header": "Contact us"
        },
        "links": {
            "header": "Useful links",
            "links": {
                "conditions": "M2PAY General Terms of Business",
                "menu": "M2PAY Price List",
                "instructions": "INSTRUCTIONS FOR USING POS DEVICES",
                "privacy-policy": "Privacy Policy"
            }
        }
    }
}